module.exports = __webpack_public_path__ + "h5/img/flower_7_3.f20b7142.svg";